const utils = {
	addParamsToBody: (data) => {
		return Object.fromEntries(Object.entries(data).filter(([key, value]) => value !== null));
	},

	convertToCents: (value) => {
		return utils.roundToPrecision(parseFloat(value) * 100, 0);
	},

	roundToPrecision: (num, precision) => {
		let factor = Math.pow(10, precision);
		return Math.round(num * factor) / factor;
	},
};

export default utils;
